// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3zSCu","list":"styles_list__2FYNC"};